function mountExpressCheckout(container, pushEventFn) {
  if (container._stripeInitialized) return;
  container._stripeInitialized = true;

  var meta = document.querySelector("meta[name='stripe-publishable-key']");
  var publishableKey = meta ? meta.getAttribute("content") : null;
  if (!publishableKey || typeof Stripe === "undefined") return;

  var clientSecret = container.dataset.clientSecret;
  if (!clientSecret) return;

  var dividerId = container.dataset.dividerId;
  var mode = container.dataset.mode || "setup";
  var amount = parseInt(container.dataset.amount || "0", 10);

  var stripe = Stripe(publishableKey);

  var elementsConfig = { appearance: { theme: "stripe" } };

  if (mode === "payment") {
    elementsConfig.mode = "payment";
    elementsConfig.amount = amount;
    elementsConfig.currency = "usd";
    elementsConfig.captureMethod = "manual";
    elementsConfig.setupFutureUsage = "off_session";
  } else {
    elementsConfig.mode = "setup";
    elementsConfig.currency = "usd";
    elementsConfig.setupFutureUsage = "off_session";
  }

  var elements = stripe.elements(elementsConfig);

  var ece = elements.create("expressCheckout", {
    buttonType: { applePay: "plain", googlePay: "plain" },
    paymentMethods: { applePay: "always", googlePay: "always" }
  });

  ece.on("ready", function (event) {
    if (event.availablePaymentMethods && dividerId) {
      var divider = document.getElementById(dividerId);
      if (divider) divider.style.display = "block";
    }
  });

  ece.mount(container);

  ece.on("confirm", async function () {
    var result = await elements.submit();
    if (result.error) {
      alert(result.error.message);
      return;
    }

    var confirmFn = mode === "payment" ? stripe.confirmPayment : stripe.confirmSetup;
    var confirmResult = await confirmFn.call(stripe, {
      elements: elements,
      clientSecret: clientSecret,
      confirmParams: { return_url: window.location.href },
      redirect: "if_required",
    });

    if (confirmResult.error) {
      alert(confirmResult.error.message);
      return;
    }

    var intent = confirmResult.paymentIntent || confirmResult.setupIntent;
    if (intent && (intent.status === "succeeded" || intent.status === "requires_capture")) {
      pushEventFn(intent.payment_method, intent.id);
    }
  });
}

export function createHook() {
  return {
    mounted() {
      var self = this;
      mountExpressCheckout(this.el, function (pmId, intentId) {
        self.pushEvent("wallet_payment_saved", {
          payment_method_id: pmId,
          payment_intent_id: intentId,
        });
      });
    },
    destroyed() {},
  };
}

export function mountOnPage() {
  function scan() {
    document
      .querySelectorAll("[data-stripe-express-checkout]")
      .forEach(function (el) {
        var formId = el.dataset.formId;
        var inputId = el.dataset.inputId;
        var postUrl = el.dataset.postUrl;

        var pushFn;
        if (formId && inputId) {
          pushFn = function (pmId, intentId) {
            document.getElementById(inputId).value = pmId;
            if (el.dataset.intentInputId && intentId) {
              document.getElementById(el.dataset.intentInputId).value = intentId;
            }
            document.getElementById(formId).querySelector("button").click();
          };
        } else if (postUrl) {
          pushFn = function (pmId, intentId) {
            var csrfTk = document
              .querySelector("meta[name='csrf-token']")
              .getAttribute("content");
            fetch(postUrl, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-csrf-token": csrfTk,
              },
              body: JSON.stringify({
                payment_method_id: pmId,
                payment_intent_id: intentId,
              }),
            })
              .then(function (r) {
                return r.json();
              })
              .then(function (data) {
                if (data.success) {
                  window.location.href = data.redirect_url;
                } else {
                  alert(data.error || "Failed to save payment method");
                }
              });
          };
        }

        if (pushFn) mountExpressCheckout(el, pushFn);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  new MutationObserver(scan).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}
